import invariant from 'invariant';

import type { I18nLocale } from '#/i18n/types/I18nLocale';

function insertScript(locale: I18nLocale, onLoaded: () => void) {
  const recaptchaScript = document.createElement('script');
  // @ts-expect-error TS(2339): Property 'recaptchaOnloadCallback' does not exist ... Remove this comment to see the full error message
  window.recaptchaOnloadCallback = onLoaded;
  recaptchaScript.setAttribute(
    'src',
    `//www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&` +
      `render=explicit&hl=${locale}`,
  );
  recaptchaScript.setAttribute('async', 'async');
  recaptchaScript.setAttribute('defer', 'defer');
  invariant(document.head, 'Missing document.head');
  document.head.appendChild(recaptchaScript);
}

let loadingPromise: Promise<typeof grecaptcha> | undefined;

export function resetRecaptcha() {
  return window?.grecaptcha?.reset();
}

export function recaptcha({ locale }: { locale: I18nLocale }) {
  loadingPromise ??= new Promise<typeof grecaptcha>((resolve) => {
    insertScript(locale, () => {
      resolve(grecaptcha);
    });
  });

  return loadingPromise;
}
